export const integracaoEnum = [
    {tipo: "BUREAU", integracao: "SERASA"},
    {tipo: "BUREAU", integracao: "PH3A"},
    {tipo: "BUREAU", integracao: "CRCP"},
    {tipo: "BACKOFFICE", integracao: "BMS"},
    {tipo: "MOTOR", integracao: "MOTOR"},
    {tipo: "MOTOR", integracao: "PEP"},
    {tipo: "BACKOFFICE", integracao: "BPO"},
    {tipo: "BACKOFFICE", integracao: "PLANNER"},
    {tipo: "BACKOFFICE", integracao: "PEER_BPO"},
    {tipo: "BACKOFFICE", integracao: "LECCA"}
]